import algoliasearch from "algoliasearch/lite"
import { urls } from "utils-lib/builds"

const algoliaClient = algoliasearch(
  urls.apiKey.GUEST.ALGOLIA_APP_ID,
  urls.apiKey.GUEST.ALGOLIA_API_KEY,
)

const searchClient = {
  applicationID: urls.apiKey.GUEST.ALGOLIA_APP_ID,
  apiKey: urls.apiKey.GUEST.ALGOLIA_API_KEY,
  search(requests) {
    const newRequests = requests.map((request) => {
      // test for empty string and change request parameter: analytics
      if (!request.params.query || request.params.query.length === 0) {
        request.params.analytics = false
      }
      return request
    })
    return algoliaClient.search(newRequests)
  },
}

export { searchClient }
